'use client'

import {useState, useEffect} from 'react'
import {usePathname, useSearchParams} from 'next/navigation'

const useHashChange = (callback) => {
	const pathname = usePathname()
	const searchParams = useSearchParams()
	const [hash, setHash] = useState('')

	useEffect(() => {
		const updateHash = () => {
			const newHash = window.location.hash
			if (newHash !== hash) {
				setHash(newHash)
				if (callback) callback()
			}
		}

		updateHash()

		window.addEventListener('hashchange', updateHash)

		return () => {
			window.removeEventListener('hashchange', updateHash)
		}
	}, [pathname, searchParams, callback, hash])

	return hash
}

export default useHashChange
